var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_25_3587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8147 13.3334C15.3772 13.3334 15.8332 12.8774 15.8332 12.3149V5.18527C15.8332 4.62275 15.3772 4.16675 14.8147 4.16675H7.68502C7.12251 4.16675 6.6665 4.62275 6.6665 5.18527",
    stroke: "#16171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_25_3587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3147 6.66675H5.18502C4.62251 6.66675 4.1665 7.12275 4.1665 7.68527V14.8149C4.1665 15.3774 4.62251 15.8334 5.18502 15.8334H12.3147C12.8772 15.8334 13.3332 15.3774 13.3332 14.8149V7.68527C13.3332 7.12275 12.8772 6.66675 12.3147 6.66675Z",
    fill: "#16171E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3147 6.66675H5.18502C4.62251 6.66675 4.1665 7.12275 4.1665 7.68527V14.8149C4.1665 15.3774 4.62251 15.8334 5.18502 15.8334H12.3147C12.8772 15.8334 13.3332 15.3774 13.3332 14.8149V7.68527C13.3332 7.12275 12.8772 6.66675 12.3147 6.66675Z",
    stroke: "#16171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_25_3587",
    x: 4.1665,
    y: 1.66675,
    width: 14.1665,
    height: 14.1667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_3587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25_3587",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_25_3587",
    x: 1.6665,
    y: 4.16675,
    width: 14.1665,
    height: 14.1667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_3587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_25_3587",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreImg);
export default __webpack_public_path__ + "static/media/more-img.acfd56f748397ae9cad8b1f11c35dbb6.svg";
export { ForwardRef as ReactComponent };